"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoAuthService = void 0;
const auth_user_helper_1 = require("./auth-user.helper");
class CognitoAuthService {
    constructor(options) {
        this.options = options;
        this.getToken = async () => (await this.options.sdk.currentSession()).getIdToken().getJwtToken();
        this.autoLogIn = () => this.withProgress(async () => {
            const user = await this.options.sdk.currentAuthenticatedUser();
            const session = await this.options.sdk.currentSession();
            return (0, auth_user_helper_1.mapUserInfo)(user, session.getIdToken().decodePayload());
        });
        this.signIn = (username, password) => this.withProgress(() => this.options.sdk.signIn(username, password));
        this.signUp = (...[username, password, attributesOrEmail, phoneNumber]) => this.withProgress(async () => {
            const attributes = { email: typeof attributesOrEmail === 'string' ? attributesOrEmail : username };
            if (typeof attributesOrEmail === 'string') {
                if (phoneNumber !== undefined)
                    attributes.phone_number = phoneNumber;
            }
            else if (attributesOrEmail) {
                for (const [key, value] of Object.entries({
                    'custom:id_organization': attributesOrEmail.id_organization,
                    'custom:id_parent': attributesOrEmail.id_parent,
                    'custom:coupon': attributesOrEmail.coupon,
                    'custom:id_sales': attributesOrEmail.id_sales,
                }))
                    if (value !== undefined)
                        attributes[key] = value;
            }
            const result = await this.options.sdk.signUp({ username, password, attributes });
            return { userName: result.userSub, email: result.user.getUsername() };
        });
        this.signInGoogle = () => this.withProgress(this.options.signInGoogle);
        this.signOut = () => this.options.sdk.signOut();
        this.verification = (username, code) => this.options.sdk.confirmSignUp(username, code);
        this.resend_verification = (username) => this.options.sdk.resendSignUp(username);
        this.forgotPassword = async (email) => {
            await this.options.sdk.forgotPassword(email);
            return {};
        };
        this.forgotPasswordSubmit = (email, code, password) => this.options.sdk.forgotPasswordSubmit(email, code, password);
        this.changePassword = async (currentPassword, password) => {
            const user = await this.options.sdk.currentAuthenticatedUser();
            return this.options.sdk.changePassword(user, currentPassword, password);
        };
        this.newPassword = (password, userSession) => this.options.sdk.completeNewPassword(userSession, password);
        this.verifyResetCode = async (_email, _code) => {
            throw new Error('Cognito verifies the code when submitting the new password. Use forgotPasswordSubmit.');
        };
        this.completePasswordReset = async (_email, _grant, _password) => {
            throw new Error('Cognito does not support database reset grants. Use forgotPasswordSubmit.');
        };
        this.setAccountStatus = async (_userId, _status) => {
            throw new Error('Database authentication is not enabled.');
        };
    }
    async withProgress(operation) {
        this.options.progress?.show();
        try {
            return await operation();
        }
        finally {
            this.options.progress?.hide();
        }
    }
}
exports.CognitoAuthService = CognitoAuthService;
